export const setVideoPlayback = (
  video: HTMLVideoElement,
  controlMethod: string,
) => {
  return video
    .play()
    .then(() => {
      // play promise has to be initialised so we can pause the video
      // otherwise we get an error
      if (controlMethod === "pause") {
        return video.pause();
      }
    })
    .catch(() => {
      // play promise throws an error if someone blocked the
      // auto playback of media in the browser
    });
};
